export default {
  // 模块名称
  personMg: {
    // 按钮类
    button: {
      add: '新增',
      edit: '修改',
      delete: '删除',
      view: '详情',
      search: '查询',
      reset: '重置',
      cancel: '取消',
      save: '保存',
      confirm: '确定',
      close: '关闭',
    },
    // 文字标签类
    label: {
      checkAll: '全选',
      nameInfo: '请按回车自动填写姓名',
      name: '姓名',
      personType: '人员类型',
      phone: '手机号',
      sex: '性别',
      createTime: '创建日期',
      startTime: '开始日期',
      endTime: '结束日期',
      IDNo: '证件号码',
      upload: '上传头像',
      groups: '名单分组',
      nationality: '国籍',
      ethnic: '名族',
      date: '出生日期',
      job: '职业',
      remark: '备注',
      groupType: '名单组类型',
      groupBlack: '黑名单',
      whiteBlack: '白名单',
      redBlack: '红名单',
      groupName: '组名称',
      IDNoType: '证件类型',
      avatar: '头像',
      faceType: '人脸类型',
      time: '开始/结束时间',
    },
    // 提示类
    placeholder: {
      select: '请选择',
      birth: '请选择出生日期',
      filterName: '请输入名称进行过滤',
      choseGroup: '请选择名单组',
      enter: '请输入',
      name: '请输入姓名',
      nationality: '请输入国籍',
      ethnic: '请输入名族',
      job: '请输入职业',
      remark: '请输入备注',
      selGender: '请选择性别',
      enterId: '请输入证件号码',
      phone: '请输入手机号',
    },
    // 消息类
    message: {
      upload: '上传头像',
      groups: '请选择名单分组',
      delete: '选择要删除的名单',
      selectDel: '删除选中名单, 是否继续?',
      successDel: '删除成功',
      failDel: '删除失败',
      targetDel: '删除该名单, 是否继续?',
      groupDel: '删除名单组, 是否继续?',
      noGroups: '无选中名单组',
      upWarn: '最大上传1张图片',
      formatWarn: '图片格式不正确, 请重新选择',
      sizeWarn: '图片大小不能超过4M',
      rightId: '请输入正确的证件号码！',
      rightName: '只能由中文、英文、数字组成',
      groupType: '请选择名单组类型',
      groupName: '请输入人员名单组名称',
      blackName: '请输入黑名单组名称',
      remark: '请输入人脸名单描述',
      value: "允许中文、字母、数字、空格、'·'、'.'、'-'，且首不能为'·'、'.'、'-'",
      sex: '请选择性别',
      name: '请输入姓名',
      nationality: '请输入国际',
      ethnic: '请输入名族',
      PleaseNumberRight: '请输入正确手机号格式',
    },
    // 标题类
    title: {
      addOk: '新增成功',
      editOk: '修改成功',
      add: '新增名单',
      edit: '修改名单',
      remind: '确认',
      addGroup: '创建人员名单组',
      editGroup: '修改人员名单组',
      detailGroup: '名单组详情',
    },
  },
}
